import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    backgroundColor: theme.palette.turmeric.main,
    padding: '30px 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
      padding: '50px',
    },
  },
});
